import { z } from "zod";

export const zLinkStd = z.object({
  view: z.literal("LinkStd"),
});

export type ZLinkStd = z.infer<typeof zLinkStd>;
